module.exports = __webpack_public_path__ + "static/media/instagram-sketched-logo.f8dc2c3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/instagram-sketched-logo.svg
// module id = 220
// module chunks = 0